var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customerCheckVouch"},[_c('div',{staticClass:"content-view"},[_c(_vm.menuList[_vm.current].component,{tag:"component",attrs:{"auth":_vm.menuList[_vm.current].auth}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }